<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="课程创建人" prop="sysName" >
        <a-input v-model="form.sysName" placeholder="请输入课程创建人" />
      </a-form-model-item>
      <a-form-model-item label="创建人手机号" prop="sysMobile" >
        <a-input v-model="form.sysMobile" placeholder="请输入创建人手机号" />
      </a-form-model-item>
      <a-form-model-item label="购买人名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入购买人名称" />
      </a-form-model-item>
      <a-form-model-item label="购买人手机号" prop="mobile" >
        <a-input v-model="form.mobile" placeholder="请输入购买人手机号" />
      </a-form-model-item>
      <a-form-model-item label="课程名称" prop="courseName" >
        <a-input v-model="form.courseName" placeholder="请输入课程名称" />
      </a-form-model-item>
      <a-form-model-item label="课程类型" prop="courseName" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.courseType">
          <a-radio :value="0">健身课程</a-radio>
          <a-radio :value="1">学院课程</a-radio>
          <a-radio :value="2">创建者课程</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="交易单号" prop="transaction" >
        <a-input v-model="form.transaction" placeholder="请输入交易单号" />
      </a-form-model-item>
      <a-form-model-item label="订单号" prop="order" >
        <a-input v-model="form.order" placeholder="请输入订单号" />
      </a-form-model-item>
      <a-form-model-item label="支付方式 " prop="type" >
      </a-form-model-item>
      <a-form-model-item label="订单金额" prop="orderMoney" >
        <a-input v-model="form.orderMoney" placeholder="请输入订单金额" />
      </a-form-model-item>
      <a-form-model-item label="学院结算金额" prop="schoolMoney" >
        <a-input v-model="form.schoolMoney" placeholder="请输入学院结算金额" />
      </a-form-model-item>
      <a-form-model-item label="是否结算 " prop="isPay" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.isPay">
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="是否完成对账" prop="isAccounts" >
        <a-radio-group name="radioGroup" :default-value="0" v-model="form.isAccounts">
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
<!--          <a-button type="primary" :loading="submitLoading" @click="submitForm">-->
<!--            保存-->
<!--          </a-button>-->
<!--          <a-button type="dashed" @click="cancel">-->
<!--            取消-->
<!--          </a-button>-->
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAccount, addAccount, updateAccount } from '@/api/account/account'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        transaction: null,

        order: null,
        name: null,
        courseName: null,
        courseType: null,
        sysMobile: null,
        sysName: null,

        type: null,

        orderMoney: null,

        schoolMoney: null,

        isPay: null,

        isAccounts: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        transaction: [
          { required: true, message: '交易单号不能为空', trigger: 'blur' }
        ],
        order: [
          { required: true, message: '订单号不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '支付方式 不能为空', trigger: 'change' }
        ],
        orderMoney: [
          { required: true, message: '订单金额不能为空', trigger: 'blur' }
        ],
        schoolMoney: [
          { required: true, message: '学院结算金额不能为空', trigger: 'blur' }
        ],
        isPay: [
          { required: true, message: '是否结算 不能为空', trigger: 'blur' }
        ],
        isAccounts: [
          { required: true, message: '是否完成对账不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        transaction: null,
        order: null,
        name: null,
        courseName: null,
        courseType: null,
        sysMobile: null,
        sysName: null,
        type: null,
        orderMoney: null,
        schoolMoney: null,
        isPay: null,
        isAccounts: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAccount({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAccount(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAccount(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
